<template>
  <div class="base-panel">
    <div class="open"></div>
    <div v-if="!url" @click="openModal" class="panel-title">{{ title }}</div>
    <div v-if="url" @click="goPage" class="panel-title">{{ title }}</div>
    <div class="panel-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePanel",
  props: {
    title: String,
    code: String,
    url: String,
    action: String,
    commit: String
  },
  methods: {
    openModal() {
      if(this.commit) {
        this.$store.commit(this.commit);
      }
      this.$store.commit("setChildModalOffsetY", 0);
      this.$store.commit("setChildModalTitle", this.title);
      this.$store.commit("setChildModalCode", this.code);
      this.$store.commit("setChildModalShow");
    },
    goPage() {
      if (this.action) {
        this.$store.dispatch(this.action);
      }
      this.$router.push({ path: this.url });
    }
  }
};
</script>

<style scoped lang="less">
.base-panel {
  overflow: hidden;
  // border: 1px solid #36a2f9;
  box-sizing: border-box;
  border-radius: 4px;
  // box-shadow: 0 0 12px 0 rgba(0, 155, 255, 0.9) inset;
  padding: 0 0px;
  margin: 0 0 0.36rem;
  color: @base-text-color;
  font-size: 0.14rem;
  position: relative;
  // background: rgba(0, 0, 0, 0.35);
  .open {
    width: 0.22rem;
    height: 0.23rem;
    background: url(../../assets/open.png);
    position: absolute;
    top: 0.06rem;
    right: 0.12rem;
    z-index: 99;
    display: none;
    cursor: pointer;
  }
}
.panel-title {
  width: 100%;
  height: 0.36rem;
  line-height: 0.36rem;
  // border-bottom: 1px solid #03a8ce;
  // box-shadow: 0px -0.16rem 0.12rem -0.06rem rgba(0, 155, 255, 0.4) inset;
  background: url(../../assets/base_panel_title.png);
  background-size: 100% 100%;
  font-size: 0.22rem;
  font-weight: bold;
  color: @light-blue;
  position: relative;
  cursor: pointer;
}
// .panel-title::before {
//   content: "";
//   width: 0.52rem;
//   height: 0.03rem;
//   position: absolute;
//   left: 0;
//   bottom: -0.02rem;
//   background: #01d7f9;
// }
// .panel-title::after {
//   content: "";
//   width: 0.52rem;
//   height: 0.03rem;
//   position: absolute;
//   right: 0;
//   bottom: -0.02rem;
//   background: #01d7f9;
// }
.panel-body {
  min-height: 2rem;
  max-height: 100%;
  padding-top: 0.18rem;
  position: relative;
  overflow: hidden;
  > div {
    width: 100%;
    min-height: 2rem;
  }
}
@media screen and (max-height: 863px) {
  .base-panel {
    margin: 0 0 0.24rem;
  }
  .panel-title {
    height: 0.3rem;
    line-height: 0.3rem;
    font-size: 0.2rem;
  }
  .panel-body {
    min-height: 1.6rem;
    > div {
      min-height: 1.6rem;
    }
  }
}
@media screen and (min-height: 1081px) {
  .base-panel {
    margin: 0 0 0.48rem;
  }
  .panel-title {
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 0.26rem;
  }
  .panel-body {
    min-height: 2.2rem;
    > div {
      min-height: 2.2rem;
    }
  }
}
</style>
